module.exports = __webpack_public_path__ + "img/11_118.5e31aa77.png";